import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ModelsPage from './pages/ModelsPage'; // Ensure this path is correct
import GetStartedPage from './pages/GetStartedPage';

const App = () => (
  <AuthProvider>
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/models" element={<ModelsPage />} /> {/* Ensure this is added */}
        <Route path="/get-started" element={<GetStartedPage />} />
      </Routes>
    </Router>
  </AuthProvider>
);

export default App;
